<template>
  <div>
    <div style="margin-top: -0.5rem;">
      <b-img
        center
        rounded
        width="100"
        src="@/assets/images/logo/logo.png"
      />
    </div>
    <b-row class="titulo-favorito">
      <b-col cols="auto">
        <span style="font-size: 24px;">Olá {{ getNomeUsuarioLogado() }},</span>
      </b-col>
    </b-row>
    <b-row
      class="titulo-favorito"
      style="font-size: 17px;"
    >
      <b-col cols="auto">
        <span>Seja muito bem vindo(a) ao Hub Auditar!</span>
      </b-col>
    </b-row>
    <b-row class="subtitulo">
      <b-col cols="auto">
        <span>Adicione suas telas favoritas aqui:</span>
      </b-col>
    </b-row>
    <div style="display: flex;justify-content: center;margin-top: -1.5rem">
      <b-row
        class="mt-3"
        align-h="center"
        style="width: 1010px;"
      >
        <favorito
          v-for="(tela, $index) in telas"
          :key="$index"
          :value="tela"
          :id-usuario="getUserId()"
          :identificador="$index"
          :telas="telas"
          @tela-salva="telaSalva($event)"
          @tela-removida="telaRemovida($event)"
        />
      </b-row>
    </div>
  </div>
</template>

<style lang="scss">
.titulo-favorito {
  justify-content: center;
  font-size: 20px;
}

.subtitulo {
  justify-content: center;
  margin-top: 1.5rem;
  font-size: 16.5px;
}
</style>

<script>
import { getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comuns/favoritos/shared/services/api'

export default {
  name: 'TelaFavoritos',
  components: {
    Favorito: () => import('./shared/components/Favoritos.vue'),
  },
  data() {
    return {
      telas: [{}, {}, {}, {}, {}, {}],
      telasAtuais: [],
    }
  },
  created() {
    const user = getUserInfo()
    api.getTelasFavoritas(user.id)
      .then(payload => {
        const dados = payload.data
        if (!dados || dados.length === 0) {
          this.telas = [{}, {}, {}, {}, {}, {}]
        } else {
          const tamanho = 6 - dados.length
          if (tamanho !== 0) {
            for (let index = 0; index < tamanho; index += 1) {
              dados.push({})
            }
          }
          this.telas = dados
        }
      })
  },
  methods: {
    getNomeUsuarioLogado() {
      const user = getUserInfo()
      if (user) {
        return user.nome
      }
      return ''
    },
    getUserId() {
      const user = getUserInfo()
      if (user) {
        return user.id
      }
      return ''
    },
    telaSalva(value) {
      this.telas.splice(value.index, 1, value.tela)
    },
    telaRemovida(value) {
      this.telas.splice(value.index, 1, {})
    },
  },
}
</script>
